import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Badge } from '@uhg-abyss/web/ui/Badge';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { isNil, isUndefined } from 'lodash';
import React from 'react';

/**
 * CoverageStatus
 *
 * Displays a badge whether the member has active or inactive coverage.
 *
 * @param activeInfo
 * @returns {Element}
 * @constructor
 */
export function CoverageStatus({ activeInfo = [] }) {
  const anyActive = activeInfo?.sources?.some((source) => {
    return source.isActive === true;
  });

  return (
    <ErrorHandler location="src/pages/private/Analysis/EidSearch/components/Details/components/CoverageStatus/CoverageStatus.jsx">
      {isNil(activeInfo) || isUndefined(anyActive) ? (
        <Badge outline variant="neutral">
          N/A
        </Badge>
      ) : (
        [
          anyActive === true && (
            <Badge
              icon={<IconSymbol color="$success1" icon="check_circle" size="$sm" variant="filled" />}
              outline
              variant="success"
            >
              Active
            </Badge>
          ),
          anyActive === false && (
            <Badge
              icon={<IconSymbol color="$error1" icon="remove_circle" size="$sm" variant="filled" />}
              outline
              variant="error"
            >
              Inactive
            </Badge>
          ),
        ]
      )}
    </ErrorHandler>
  );
}
